export default __webpack_public_path__ + "static/media/js.669e3d93.svg";